export default __webpack_public_path__ + "static/media/Hospital&Pathology.2b795d2e.svg";